<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.975L20.1501 7.4L9.5501 18Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconDone'
}
</script>
